// import React from "react";
// // import guruImage from "../assets/assets/Picture1.jpg";
// import Navbar from "./Header";
// import Footer from "./Footer";
// import guruImage from "../assets/Picture1.jpg";
// import sukhadev from "../assets/sukhadev.png";
// import pooja from "../assets/pooja.jpg";
// import Girija from "../assets/Girija.jpg";
// import Vaishali from "../assets/Vaishali.jpg";
// import Shrutika from "../assets/Shrutika.jpg";
// import Prerana from "../assets/Prerana.jpg";
// import Jayashree from "../assets/Jayashree.jpg";
// import Rahul from "../assets/Rahul.jpg";
// import Ujwala from "../assets/Ujwala.jpg";
// import Sheetal from "../assets/Sheetal.jpg";
// import Shilpa from "../assets/Shilpa.jpg";
// import Sharali from "../assets/Sharali.jpg";
// import Sameena from "../assets/Sameena.jpg";
// import Akanksha from "../assets/Akanksha.jpg";
// import Poonam from "../assets/Poonam.jpg";
// import Akshata from "../assets/Akshata.jpg";
// import Rachana from "../assets/Rachana.jpg";
// import Shrushti from "../assets/Shrushti.jpg";
// import Divya from "../assets/Divya.jpg";
// import Pradnya from "../assets/Pradnya.jpg";
// import Shubhangi from "../assets/Shubhangi.jpg";
// import Nikita from "../assets/Nikita.jpg";
// import Ankita from "../assets/Ankita.jpg";
// import Arpita from "../assets/Arpita.jpg";


// const Faculties = () => {
//   const faculties = [
//     { name: "Mr. Sukhadev S Koli", qualification: "DSCE, BCA, MCSE", role: "Manager & IT Head", image: sukhadev },
//     { name: "Miss. Pooja S Kore", qualification: "B. Sc. B. Ed.", role: "Science Dept", image: pooja },
//     { name: "Miss. Girija M Allikatte", qualification: "M A B. Ed.", role: "Kannada Dept", image: Girija },
//     { name: "Mrs. Vaishali B Toanage", qualification: "M A B. Ed.", role: "Hindi Dept", image: Vaishali },
//     { name: "Miss. Shrutika Ghenappagol", qualification: "M. Sc. B. Ed.", role: "Science Dept", image: Shrutika },
//     { name: "Mrs. Prerana Nandani", qualification: "B. Sc. D. Ed.", role: "Maths Dept", image: Prerana },
//     { name: "Mrs. Jayashree Kanappatil", qualification: "Dip in Art", role: "Art & Craft Dept", image: Jayashree },
//     { name: "Mr. Rahul Badiger", qualification: "M. P. Ed.", role: "Physical Instructor", image: Rahul },
//     { name: "Mrs. Ujwala Gadale", qualification: "B A D. Ed.", role: "Kannada Dept", image: Ujwala },
//     { name: "Miss. Sheetal Katkar", qualification: "B Sc. B. Ed.", role: "Maths Dept", image: Sheetal },
//     { name: "Mrs. Shilpa Magadum", qualification: "B A B. Ed.", role: "English Dept", image: Shilpa },
//     { name: "Mrs. Sharali Shidhe", qualification: "M. A B. Ed.", role: "English Dept", image: Sharali },
//     { name: "Mrs. Sameena Shekh", qualification: "B. Com, NTC", role: "KG Section", image: Sameena },
//     { name: "Miss. Akanksha Torase", qualification: "PU NTC, D. Ed", role: "KG Section", image: Akanksha },
//     { name: "Miss. Poonam Trivedi", qualification: "BA LLB", role: "English Dept.", image: Poonam },
//     { name: "Miss Akshata Kore", qualification: "B Com.", role: "KG Section", image: Akshata },
//     { name: "Miss. Rachana Kothale", qualification: "M. A in Psychology", role: "Special Educator", image: Rachana },
//     { name: "Miss. Shrushti Anagali", qualification: "BCA NTC", role: "KG Section", image: Shrushti },
//     { name: "Miss. Divya Koli", qualification: "B Com.", role: "KG Section", image: Divya },
//     { name: "Miss. Pradnya Kuchnure", qualification: "BCA", role: "Comp Dept", image: Pradnya },
//     { name: "Miss. Shubhangi Koli", qualification: "B Com", role: "Accountant", image: Shubhangi },
//     { name: "Miss. Nikita Gane", qualification: "B. Com. NTC", role: "KG Section", image: Nikita },
//     { name: "Miss. Ankita Babannavar", qualification: "B Sc.", role: "Primary Section", image: Ankita },
//     { name: "Miss. Arpita Nandre", qualification: "B Sc. NTC", role: "KG Section", image: Arpita },
//   ];

//   return (
//     <>
//       <Navbar />
      


//       <div className="about-container">
       

//         {/* Faculty Section */}
//         <section className="faculty-section">
//           <h2 className="section-title">
//             <span className="title-decorator"></span>
//             Our Esteemed Faculty
//           </h2>
//           <div className="faculty-grid">
//             {faculties.map((faculty, index) => (
//               <div key={index} className="faculty-card">
//                 <div className="faculty-img-container">
//                   <img
//                     src={faculty.image}
//                     alt={faculty.name}
//                     className="faculty-image"
//                   />
//                   <div className="faculty-overlay">
//                     <p><strong>Qualification:</strong> {faculty.qualification}</p>
//                   </div>
//                 </div>
//                 <div className="faculty-info">
//                   <h3>{faculty.name}</h3>
//                   <p className="department">{faculty.role}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </section>
//       </div>
      
//       <Footer />

//       <style>{`
//         /* Base Styles */
//         :root {
//           --primary-color: #0f2b6e;
//           --secondary-color: #f9a826;
//           --accent-color: #4a6fdc;
//           --light-bg: #f9fafc;
//           --dark-text: #333;
//           --light-text: #fff;
//           --card-shadow: 0 10px 30px rgba(0,0,0,0.1);
//           --transition: all 0.3s ease;
//         }
        
//         * {
//           box-sizing: border-box;
//           margin: 0;
//           padding: 0;
//         }
        
//         body {
//           font-family: 'Poppins', sans-serif;
//           color: var(--dark-text);
//           line-height: 1.6;
//           overflow-x: hidden;
//         }
        
//         /* Hero Section */
//         .hero-section {
//           height: 80vh;
//           min-height: 500px;
//           background: linear-gradient(rgba(15, 43, 110, 0.8), rgba(15, 43, 110, 0.9)), 
//                       url('../assets/assets/school-bg.jpg') center/cover no-repeat;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           text-align: center;
//           position: relative;
//           overflow: hidden;
//           margin-bottom: 60px;
//         }
        
//         .hero-overlay {
//           position: absolute;
//           top: 0;
//           left: 0;
//           width: 100%;
//           height: 100%;
//           background: radial-gradient(circle at center, transparent 0%, rgba(15, 43, 110, 0.9) 100%);
//         }
        
//         .hero-content {
//           position: relative;
//           z-index: 2;
//           max-width: 800px;
//           padding: 0 20px;
//           color: var(--light-text);
//           animation: fadeInUp 1s ease;
//         }
        
//         .hero-title {
//           font-size: 3.5rem;
//           font-weight: 700;
//           margin-bottom: 20px;
//           text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
//         }
        
//         .hero-subtitle {
//           font-size: 1.5rem;
//           font-weight: 300;
//           margin-bottom: 40px;
//           opacity: 0.9;
//         }
        
//         .scroll-indicator {
//           margin-top: 50px;
//           animation: bounce 2s infinite;
//         }
        
//         .scroll-indicator span {
//           display: block;
//           width: 30px;
//           height: 50px;
//           border: 2px solid var(--light-text);
//           border-radius: 15px;
//           margin: 0 auto;
//           position: relative;
//         }
        
//         .scroll-indicator span:before {
//           content: '';
//           position: absolute;
//           top: 8px;
//           left: 50%;
//           width: 6px;
//           height: 6px;
//           background: var(--light-text);
//           border-radius: 50%;
//           transform: translateX(-50%);
//           animation: scrollDown 2s infinite;
//         }
        
//         /* About Container */
//         .about-container {
//           max-width: 1200px;
//           margin: 0 auto;
//           padding: 0 20px 80px;
//         }
        
//         /* Section Titles */
//         .section-title {
//           font-size: 2.2rem;
//           color: var(--primary-color);
//           margin-bottom: 40px;
//           position: relative;
//           display: inline-block;
//           padding-left: 20px;
//         }
        
//         .title-decorator {
//           position: absolute;
//           left: 0;
//           top: 50%;
//           transform: translateY(-50%);
//           width: 8px;
//           height: 40px;
//           background: var(--secondary-color);
//           border-radius: 4px;
//         }
        
//         /* About Section */
//         .about-section {
//           display: flex;
//           gap: 60px;
//           margin: 80px 0;
//           align-items: center;
//         }
        
//         .about-text {
//           flex: 1.5;
//           animation: fadeInLeft 1s ease;
//         }
        
//         .about-image {
//           flex: 1;
//           position: relative;
//           animation: fadeInRight 1s ease;
//         }
        
//         .image-frame {
//           position: relative;
//           border-radius: 15px;
//           overflow: hidden;
//           box-shadow: var(--card-shadow);
//           transition: var(--transition);
//         }
        
//         .image-frame:before {
//           content: '';
//           position: absolute;
//           top: 0;
//           left: 0;
//           width: 100%;
//           height: 100%;
//           background: linear-gradient(135deg, rgba(15,43,110,0.3) 0%, rgba(249,168,38,0.1) 100%);
//           z-index: 1;
//         }
        
//         .founder-img {
//           width: 100%;
//           height: auto;
//           display: block;
//           transition: transform 0.5s ease;
//         }
        
//         .image-frame:hover .founder-img {
//           transform: scale(1.05);
//         }
        
//         .image-caption {
//           text-align: center;
//           margin-top: 15px;
//           font-style: italic;
//           color: #666;
//           font-size: 0.9rem;
//         }
        
//         .highlight-text {
//           background: rgba(15, 43, 110, 0.05);
//           padding: 20px;
//           border-left: 4px solid var(--primary-color);
//           font-size: 1.1rem;
//           margin-bottom: 25px;
//           border-radius: 0 8px 8px 0;
//         }
        
//         /* Mission Vision Values */
//         .mv-section {
//           margin: 100px 0;
//         }
        
//         .mv-container {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
//           gap: 40px;
//           margin-top: 50px;
//         }
        
//         .mv-card {
//           padding: 40px 30px;
//           border-radius: 12px;
//           box-shadow: 0 5px 15px rgba(0,0,0,0.05);
//           transition: var(--transition);
//           position: relative;
//           overflow: hidden;
//           z-index: 1;
//           background: var(--light-bg);
//           text-align: center;
//         }
        
//         .mv-card:before {
//           content: '';
//           position: absolute;
//           top: 0;
//           left: 0;
//           width: 100%;
//           height: 5px;
//         }
        
//         .mission:before { background: var(--accent-color); }
//         .vision:before { background: #6c5ce7; }
//         .values:before { background: #e84393; }
        
//         .mv-card:hover {
//           transform: translateY(-10px);
//           box-shadow: 0 15px 30px rgba(0,0,0,0.1);
//         }
        
//         .mv-card h3 {
//           color: var(--primary-color);
//           margin: 25px 0 15px;
//           font-size: 1.5rem;
//         }
        
//         .mv-icon {
//           width: 70px;
//           height: 70px;
//           margin: 0 auto;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           background: rgba(74, 111, 220, 0.1);
//           border-radius: 50%;
//         }
        
//         .mv-icon svg {
//           width: 32px;
//           height: 32px;
//           fill: var(--accent-color);
//         }
        
//         .vision .mv-icon {
//           background: rgba(108, 92, 231, 0.1);
//         }
        
//         .vision .mv-icon svg {
//           fill: #6c5ce7;
//         }
        
//         .values .mv-icon {
//           background: rgba(232, 67, 147, 0.1);
//         }
        
//         .values .mv-icon svg {
//           fill: #e84393;
//         }
        
//         /* Board Members */
//         .management-section {
//           margin: 100px 0;
//         }
        
//         .board-list {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
//           gap: 40px;
//           margin-top: 50px;
//         }
        
//         .board-member {
//           background: white;
//           padding: 30px;
//           border-radius: 12px;
//           text-align: center;
//           box-shadow: var(--card-shadow);
//           transition: var(--transition);
//           position: relative;
//           overflow: hidden;
//         }
        
//         .board-member:hover {
//           transform: translateY(-10px);
//         }
        
//         .member-img-container {
//           width: 150px;
//           height: 150px;
//           border-radius: 50%;
//           overflow: hidden;
//           margin: 0 auto 25px;
//           position: relative;
//         }
        
//         .img-border {
//           position: absolute;
//           top: -5px;
//           left: -5px;
//           right: -5px;
//           bottom: -5px;
//           border: 2px solid var(--secondary-color);
//           border-radius: 50%;
//           z-index: 1;
//           animation: rotate 8s linear infinite;
//         }
        
//         .member-img-container img {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//           border-radius: 50%;
//         }
        
//         .board-member h4 {
//           color: var(--primary-color);
//           margin: 15px 0 5px;
//           font-size: 1.3rem;
//         }
        
//         .position {
//           color: var(--secondary-color);
//           font-weight: 600;
//           margin-bottom: 5px;
//           font-size: 1rem;
//         }
        
//         /* Full Board Members */
//         .board-section {
//           margin: 100px 0;
//           background: var(--light-bg);
//           padding: 60px 40px;
//           border-radius: 20px;
//           position: relative;
//           overflow: hidden;
//         }
        
//         .board-section:before {
//           content: '';
//           position: absolute;
//           top: 0;
//           left: 0;
//           width: 100%;
//           height: 5px;
//           background: linear-gradient(90deg, var(--primary-color), var(--secondary-color));
//         }
        
//         .board-banner {
//           margin: 50px 0;
//           text-align: center;
//           border-radius: 12px;
//           overflow: hidden;
//           box-shadow: var(--card-shadow);
//         }
        
//         .board-banner img {
//           width: 100%;
//           height: auto;
//           display: block;
//           transition: transform 0.5s ease;
//         }
        
//         .board-banner:hover img {
//           transform: scale(1.02);
//         }
        
//         .board-names-container {
//           display: flex;
//           flex-wrap: wrap;
//           gap: 60px;
//           justify-content: center;
//           margin-top: 40px;
//         }
        
//         .board-names-column {
//           flex: 1;
//           min-width: 300px;
//         }
        
//         .board-names {
//           list-style: none;
//           padding: 0;
//           margin: 0;
//         }
        
//         .board-names li {
//           padding: 15px 0;
//           border-bottom: 1px solid #eee;
//           font-size: 1.05rem;
//           position: relative;
//           padding-left: 30px;
//           transition: var(--transition);
//         }
        
//         .board-names li:hover {
//           transform: translateX(5px);
//         }
        
//         .board-names li:before {
//           content: '';
//           position: absolute;
//           left: 0;
//           top: 22px;
//           width: 12px;
//           height: 12px;
//           background: var(--secondary-color);
//           border-radius: 50%;
//         }
        
//         .name {
//           font-weight: 600;
//           color: var(--primary-color);
//         }
        
//         /* Faculty Section */
//         .faculty-section {
//           margin: 100px 0;
//         }
        
//         .faculty-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
//           gap: 30px;
//           margin-top: 50px;
//         }
        
//         .faculty-card {
//           background: white;
//           border-radius: 12px;
//           overflow: hidden;
//           box-shadow: var(--card-shadow);
//           transition: var(--transition);
//         }
        
//         .faculty-card:hover {
//           transform: translateY(-10px);
//           box-shadow: 0 15px 30px rgba(0,0,0,0.15);
//         }
        
//         .faculty-img-container {
//           position: relative;
//           height: 250px;
//           overflow: hidden;
//         }
        
//         .faculty-image {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//           transition: transform 0.5s ease;
//         }
        
//         .faculty-overlay {
//           position: absolute;
//           bottom: -100%;
//           left: 0;
//           width: 100%;
//           padding: 20px;
//           background: rgba(15, 43, 110, 0.9);
//           color: white;
//           transition: bottom 0.3s ease;
//         }
        
//         .faculty-card:hover .faculty-overlay {
//           bottom: 0;
//         }
        
//         .faculty-info {
//           padding: 20px;
//           text-align: center;
//         }
        
//         .faculty-info h3 {
//           color: var(--primary-color);
//           margin-bottom: 5px;
//           font-size: 1.2rem;
//         }
        
//         .department {
//           color: var(--secondary-color);
//           font-weight: 500;
//           font-size: 0.9rem;
//         }
        
//         /* Animations */
//         @keyframes fadeInUp {
//           from {
//             opacity: 0;
//             transform: translateY(20px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }
        
//         @keyframes fadeInLeft {
//           from {
//             opacity: 0;
//             transform: translateX(-20px);
//           }
//           to {
//             opacity: 1;
//             transform: translateX(0);
//           }
//         }
        
//         @keyframes fadeInRight {
//           from {
//             opacity: 0;
//             transform: translateX(20px);
//           }
//           to {
//             opacity: 1;
//             transform: translateX(0);
//           }
//         }
        
//         @keyframes bounce {
//           0%, 20%, 50%, 80%, 100% {
//             transform: translateY(0);
//           }
//           40% {
//             transform: translateY(-20px);
//           }
//           60% {
//             transform: translateY(-10px);
//           }
//         }
        
//         @keyframes scrollDown {
//           0% {
//             opacity: 1;
//             transform: translate(-50%, 0);
//           }
//           100% {
//             opacity: 0;
//             transform: translate(-50%, 15px);
//           }
//         }
        
//         @keyframes rotate {
//           from {
//             transform: rotate(0deg);
//           }
//           to {
//             transform: rotate(360deg);
//           }
//         }
        
//         /* Responsive Adjustments */
//         @media (max-width: 992px) {
//           .hero-title {
//             font-size: 2.8rem;
//           }
          
//           .about-section {
//             flex-direction: column;
//           }
          
//           .about-image {
//             order: -1;
//             margin-bottom: 40px;
//             max-width: 500px;
//           }
//         }
        
//         @media (max-width: 768px) {
//           .hero-title {
//             font-size: 2.2rem;
//           }
          
//           .hero-subtitle {
//             font-size: 1.2rem;
//           }
          
//           .section-title {
//             font-size: 1.8rem;
//           }
          
//           .mv-container {
//             grid-template-columns: 1fr;
//           }
          
//           .board-names-column {
//             min-width: 100%;
//           }
//         }
        
//         @media (max-width: 576px) {
//           .hero-title {
//             font-size: 1.8rem;
//           }
          
//           .board-section {
//             padding: 40px 20px;
//           }
          
//           .faculty-grid {
//             grid-template-columns: 1fr;
//           }
//         }


//         /* Desk Messages */
// .desk-messages-container {
//   display: flex;
//   flex-direction: column;
//   gap: 60px;
//   margin-bottom: 80px;
// }

// .desk-message {
//   background: white;
//   border-radius: 12px;
//   overflow: hidden;
//   box-shadow: var(--card-shadow);
//   transition: var(--transition);
//   padding: 30px;
// }

// .desk-message:hover {
//   transform: translateY(-5px);
//   box-shadow: 0 10px 25px rgba(0,0,0,0.1);
// }

// .message-header {
//   display: flex;
//   align-items: center;
//   gap: 30px;
//   margin-bottom: 30px;
// }

// .message-title h3 {
//   color: var(--primary-color);
//   font-size: 1.5rem;
//   margin-bottom: 10px;
// }

// .message-title h4 {
//   color: var(--dark-text);
//   font-size: 1.2rem;
//   margin-bottom: 5px;
// }

// .message-title .position {
//   color: var(--secondary-color);
//   font-weight: 600;
//   font-size: 0.9rem;
// }

// .message-content {
//   color: #555;
//   line-height: 1.8;
// }

// .message-content p {
//   margin-bottom: 15px;
// }

// .message-signature {
//   margin-top: 30px;
//   padding-top: 20px;
//   border-top: 1px solid #eee;
//   font-style: italic;
// }

// .message-signature p {
//   margin-bottom: 5px;
// }

// /* Responsive adjustments for desk messages */
// @media (max-width: 768px) {
//   .message-header {
//     flex-direction: column;
//     text-align: center;
//     gap: 20px;
//   }
  
//   .message-title h3 {
//     font-size: 1.3rem;
//   }
  
//   .message-title h4 {
//     font-size: 1.1rem;
//   }
// }
//       `}</style>
//     </>
//   );
// };

// export default Faculties;













import React from "react";
import Navbar from "./Header";
import Footer from "./Footer";

const Faculties = () => {
  const faculties = [
    { name: "Mr. Sukhadev S Koli", qualification: "DSCE, BCA, MCSE", role: "Manager & IT Head", image: require('../assets/sukhadev.png') },
    { name: "Miss. Pooja S Kore", qualification: "B. Sc. B. Ed.", role: "Science Dept", image: require('../assets/pooja.jpg') },
    { name: "Miss. Girija M Allikatte", qualification: "M A B. Ed.", role: "Kannada Dept", image: require('../assets/Girija.jpg') },
    { name: "Mrs. Vaishali B Toanage", qualification: "M A B. Ed.", role: "Hindi Dept", image: require('../assets/Vaishali.jpg') },
    { name: "Miss. Shrutika Ghenappagol", qualification: "M. Sc. B. Ed.", role: "Science Dept", image: require('../assets/Shrutika.jpg') },
    { name: "Mrs. Prerana Nandani", qualification: "B. Sc. D. Ed.", role: "Maths Dept", image: require('../assets/Prerana.jpg') },
    { name: "Mrs. Jayashree Kanappatil", qualification: "Dip in Art", role: "Art & Craft Dept", image: require('../assets/Jayashree.jpg') },
    { name: "Mr. Rahul Badiger", qualification: "M. P. Ed.", role: "Physical Instructor", image: require('../assets/Rahul.jpg') },
    { name: "Mrs. Ujwala Gadale", qualification: "B A D. Ed.", role: "Kannada Dept", image: require('../assets/Ujwala.jpg') },
    { name: "Miss. Sheetal Katkar", qualification: "B Sc. B. Ed.", role: "Maths Dept", image: require('../assets/Sheetal.jpg') },
    { name: "Mrs. Shilpa Magadum", qualification: "B A B. Ed.", role: "English Dept", image: require('../assets/Shilpa.jpg') },
    { name: "Mrs. Sharali Shidhe", qualification: "M. A B. Ed.", role: "English Dept", image: require('../assets/Sharali.jpg') },
    { name: "Mrs. Sameena Shekh", qualification: "B. Com, NTC", role: "KG Section", image: require('../assets/Sameena.jpg') },
    { name: "Miss. Akanksha Torase", qualification: "PU NTC, D. Ed", role: "KG Section", image: require('../assets/Akanksha.jpg') },
    { name: "Miss. Poonam Trivedi", qualification: "BA LLB", role: "English Dept.", image: require('../assets/Poonam.jpg') },
    { name: "Miss Akshata Kore", qualification: "B Com.", role: "KG Section", image: require('../assets/Akshata.jpg') },
    { name: "Miss. Rachana Kothale", qualification: "M. A in Psychology", role: "Special Educator", image: require('../assets/Rachana.jpg') },
    { name: "Miss. Shrushti Anagali", qualification: "BCA NTC", role: "KG Section", image: require('../assets/Shrushti.jpg') },
    { name: "Miss. Divya Koli", qualification: "B Com.", role: "KG Section", image: require('../assets/Divya.jpg') },
    { name: "Miss. Pradnya Kuchnure", qualification: "BCA", role: "Comp Dept", image: require('../assets/Pradnya.jpg') },
    { name: "Miss. Shubhangi Koli", qualification: "B Com", role: "Accountant", image: require('../assets/Shubhangi.jpg') },
    { name: "Miss. Nikita Gane", qualification: "B. Com. NTC", role: "KG Section", image: require('../assets/Nikita.jpg') },
    { name: "Miss. Ankita Babannavar", qualification: "B Sc.", role: "Primary Section", image: require('../assets/Ankita.jpg') },
    { name: "Miss. Arpita Nandre", qualification: "B Sc. NTC", role: "KG Section", image: require('../assets/Arpita.jpg') },
  ];

  return (
    <>
      <Navbar />
      
      <div className="faculty-page">
        {/* Hero Banner */}
        {/* <div className="faculty-hero">
          <div className="hero-overlay"></div>
          <div className="hero-content">
            <h1>Our Esteemed Faculty</h1>
            <p>Dedicated educators shaping the future of our students</p>
          </div>
        </div> */}

        {/* Faculty Grid */}
        <div className="faculty-container">

          <div className="faculty-grid">
            {faculties.map((faculty, index) => (
              <div key={index} className="faculty-card">
                <div className="card-image">
                  <img src={faculty.image} alt={faculty.name} />
                  <div className="image-overlay"></div>
                </div>
                <div className="card-content">
                  <h3>{faculty.name}</h3>
                  <p className="department">{faculty.role}</p>
                  <div className="qualification">
                    <span>Qualification:</span> {faculty.qualification}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <Footer />

      <style>{`
        /* Base Styles */
        :root {
          --primary-color: #0f2b6e;
          --secondary-color: #f9a826;
          --accent-color: #4a6fdc;
          --light-bg: #f9fafc;
          --dark-text: #333;
          --light-text: #fff;
          --card-shadow: 0 10px 30px rgba(0,0,0,0.1);
          --transition: all 0.3s ease;
        }
        
        * {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }
        
        body {
          font-family: 'Poppins', sans-serif;
          color: var(--dark-text);
          line-height: 1.6;
        }
        
        /* Faculty Page */
        .faculty-page {
          width: 100%;
          overflow-x: hidden;
        }
        
        /* Hero Section */
        .faculty-hero {
          height: 60vh;
          min-height: 400px;
          background: linear-gradient(rgba(15, 43, 110, 0.8), rgba(15, 43, 110, 0.9)), 
                      url('../assets/school-bg.jpg') center/cover no-repeat;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          position: relative;
          margin-bottom: 60px;
        }
        
        .hero-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: radial-gradient(circle at center, transparent 0%, rgba(15, 43, 110, 0.7) 100%);
        }
        
        .hero-content {
          position: relative;
          z-index: 2;
          max-width: 800px;
          padding: 0 20px;
          color: var(--light-text);
        }
        
        .hero-content h1 {
          font-size: 3rem;
          font-weight: 700;
          margin-bottom: 20px;
          text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
        }
        
        .hero-content p {
          font-size: 1.5rem;
          font-weight: 300;
          opacity: 0.9;
        }
        
        /* Faculty Container */
        .faculty-container {
          max-width: 1400px;
          margin: 0 auto;
          padding: 0 20px 80px;
        }
        
        /* Faculty Grid */
        .faculty-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
          gap: 30px;
          margin-top: 30px;
        }
        
        /* Faculty Card */
        .faculty-card {
          background: white;
          border-radius: 15px;
          overflow: hidden;
          box-shadow: var(--card-shadow);
          transition: var(--transition);
          position: relative;
        }
        
        .faculty-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 15px 40px rgba(0,0,0,0.15);
        }
        
        /* Card Image */
        .card-image {
          position: relative;
          height: 300px;
          overflow: hidden;
        }
        
        .card-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s ease;
        }
        
        .faculty-card:hover .card-image img {
          transform: scale(1.05);
        }
        
        .image-overlay {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 50%;
          background: linear-gradient(to top, rgba(15,43,110,0.7), transparent);
        }
        
        /* Card Content */
        .card-content {
          padding: 25px;
          text-align: center;
          position: relative;
          z-index: 1;
        }
        
        .card-content h3 {
          color: var(--primary-color);
          font-size: 1.3rem;
          margin-bottom: 8px;
          font-weight: 600;
        }
        
        .department {
          color: var(--secondary-color);
          font-weight: 500;
          font-size: 1rem;
          margin-bottom: 15px;
          display: block;
        }
        
        .qualification {
          font-size: 0.9rem;
          color: #555;
          line-height: 1.5;
        }
        
        .qualification span {
          font-weight: 600;
          color: var(--primary-color);
        }
        
        /* Responsive Design */
        @media (max-width: 1200px) {
          .faculty-grid {
            grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
          }
        }
        
        @media (max-width: 992px) {
          .faculty-hero {
            height: 50vh;
            min-height: 350px;
          }
          
          .hero-content h1 {
            font-size: 2.5rem;
          }
          
          .hero-content p {
            font-size: 1.3rem;
          }
        }
        
        @media (max-width: 768px) {
          .faculty-hero {
            height: 40vh;
            min-height: 300px;
          }
          
          .hero-content h1 {
            font-size: 2rem;
          }
          
          .hero-content p {
            font-size: 1.1rem;
          }
          
          .faculty-grid {
            grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
            gap: 20px;
          }
          
          .card-image {
            height: 250px;
          }
        }
        
        @media (max-width: 576px) {
          .faculty-hero {
            height: 35vh;
            min-height: 250px;
          }
          
          .hero-content h1 {
            font-size: 1.8rem;
          }
          
          .hero-content p {
            font-size: 1rem;
          }
          
          .faculty-container {
            padding: 0 15px 60px;
          }
          
          .faculty-grid {
            grid-template-columns: 1fr;
            gap: 25px;
          }
          
          .card-image {
            height: 280px;
          }
          
          .card-content {
            padding: 20px;
          }
          
          .card-content h3 {
            font-size: 1.2rem;
          }
        }
      `}</style>
    </>
  );
};

export default Faculties;